// extracted by mini-css-extract-plugin
export default {"NewBlog":"NewCategory_NewBlog__X5GCV","logo":"NewCategory_logo__Hga19","close":"NewCategory_close__xGlix","actionLink":"NewCategory_actionLink__r+VJW"};